import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/cn";

const landingButtonVariants = cva(
  cn(
    "inline-flex h-[2.625rem] w-[10.625rem] shrink-0 cursor-pointer items-center justify-center gap-2 rounded-3xl px-6",
    "text-[0.875rem] leading-none font-semibold whitespace-nowrap transition-colors duration-300",
    "outline-none focus-visible:ring-4 focus-visible:ring-landing-ink/10 disabled:pointer-events-none disabled:opacity-40"
  ),
  {
    variants: {
      variant: {
        dark: "bg-landing-button text-white hover:bg-landing-button/85 active:bg-landing-button/75",
        light:
          "bg-white text-landing-ink border border-landing-border hover:border-landing-ink/20 hover:bg-neutral-50 active:bg-neutral-100",
      },
    },
    defaultVariants: {
      variant: "dark",
    },
  }
);

interface LandingButtonProps
  extends
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof landingButtonVariants> {
  asChild?: boolean;
}

export const LandingButton = ({ className, variant, asChild, ...props }: LandingButtonProps) => {
  const Comp = asChild ? Slot : "button";
  return (
    <Comp
      data-slot="landing-button"
      className={cn(landingButtonVariants({ variant }), className)}
      {...props}
    />
  );
};
